<template>
  <div class="home-page" :style="{ backgroundImage: `url(${homeBg})` }">
    <div class="home-content">
      <img :src="homeTxt" alt="" class="home-intro" />

      <div class="book-list">
        <article
          v-for="book in books"
          :key="book.id"
          class="book-card"
          @click="goToBook(book.id)"
        >
          <img
            v-if="getBookCover(book)"
            :src="getBookCover(book)"
            :alt="book.title"
            class="book-cover-img"
          />
        </article>
      </div>
    </div>

    <nav class="bottom-nav">
      <div class="nav-item active">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3l9 8v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V11l9-8z" fill="currentColor" />
        </svg>
        <span class="nav-text">首页</span>
      </div>
      <div class="nav-item" @click="goToMine">
        <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm0 2c-4.42 0-8 2.24-8 5v1h16v-1c0-2.76-3.58-5-8-5z" fill="currentColor" />
        </svg>
        <span class="nav-text">我的</span>
      </div>
    </nav>
  </div>
</template>

<script>
import { getBooks } from '@/api/book'
import homeTxt from '@/assets/home-txt.png'
import homeBg from '@/assets/home-bg.jpg'

export default {
  name: 'BookList',
  data() {
    return {
      homeTxt,
      homeBg,
      books: [],
      loading: false
    }
  },
  created() {
    this.fetchBooks()
  },
  methods: {
    async fetchBooks() {
      this.loading = true
      try {
        const res = await getBooks()
        this.books = res.data || []
      } catch (error) {
        console.error('获取绘本列表失败:', error)
        this.books = []
      } finally {
        this.loading = false
      }
    },
    getBookCover(book) {
      return book.icon || book.cover || ''
    },
    goToBook(id) {
      this.$router.push(`/story-practice/${id}`)
    },
    goToMine() {
      this.$router.push('/records')
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background-color: #e8f0c1;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
}

.home-content {
  padding: 16px 16px 24px;
}

.home-intro {
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.book-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.book-card {
  overflow: hidden;
  cursor: pointer;
}

.book-card:active {
  opacity: 0.92;
}

.book-cover-img {
  display: block;
  width: 100%;
  height: auto;
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(56px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.06);
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 96px;
  padding: 8px 16px;
  cursor: pointer;
  color: #999;
}

.nav-item.active {
  color: #00b5ad;
}

.nav-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-text {
  font-size: 14px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/BookList.vue